module.exports = __webpack_public_path__ + "img/四川天府新区第五幼儿园.f6ebe118.jpg";